import { Injectable, signal } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { AskGraphs, LoadForecastSuccessPayload } from '@library/store/homes/homes.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { UserFacade } from '@library/store/user/user.facade';
import { Enums } from 'constants/Enums.constant';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CpForecastService {

  forecast = signal<LoadForecastSuccessPayload>(null);

  constructor(
    private homesFacade: HomesFacade,
    private modulesFacade: ModulesFacade,
    private userFacade: UserFacade,
  ) {}

  async loadForecast() {
    const home = await firstValueFrom(this.homesFacade.currentHome$);
    const modules = await firstValueFrom(this.modulesFacade.currentHomeModules$);
    const currentUser = await firstValueFrom(this.userFacade.currentUser$);

    const station = modules.find(m => m.type === Enums.ModuleType.NAMAIN);
    const outdoorModule = modules.find(m => m.type === Enums.ModuleType.NAMODULE1);

    const module = home.mode === 'favorite' ? outdoorModule : station;

    if (module) {
      const {payload} = await firstValueFrom(this.homesFacade.loadForecast({
        device_id: module.bridge ?? module.id,
        module_id: module.id,
        locale: currentUser.locale,
        ask_graphs: [
          AskGraphs.RAIN,
          AskGraphs.WIND,
          AskGraphs.TEMPERATURE,
          AskGraphs.RAIN_PROBA,
          AskGraphs.HUMIDITY,
          AskGraphs.SYMBOL
        ],
      }));

      Object.entries(payload.forecastGraphs).forEach(([measureType, values]) => {
        payload.forecastGraphs[measureType] = values.filter(([, value]) => value !== null);
      });

      this.forecast.set(payload);
    }
  }
}